
import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import VueI18n from "vue-i18n";

@Component({
  name: 'HeaderNav'
})
export default class HeaderNav extends Vue {
  @Prop({ default: '' }) readonly title!: string | VueI18n.TranslateResult
  @Prop({ default: '', type: String }) readonly rightText!: string
  @Prop({ default: '', type: String }) readonly leftText!: string
}
